import { Transaction } from 'dexie';
import { LocalDb } from './local-db';
import { fields } from './local-db-utils';
import { ActivitySync } from './objects/activity-sync';
import { Example } from './objects/example';
import {
  HarvestActivityReport,
  HarvestActivityReportSyncState
} from './objects/harvest-activity-report';
import { LocalConfiguration } from './objects/local-configuration';
import { MachineSync } from './objects/machine-sync';
import { ProgrammingSync } from './objects/programming-sync';
import { ShiftSync } from './objects/shift-sync';
import { SynchronizationStatus } from './objects/synchronization-status';
import { TeamSync } from './objects/team-sync';

export class Migrator {
  private readonly _db: LocalDb;
  private readonly _migrations = migrations;

  constructor(db: LocalDb) {
    this._db = db;
  }

  async updateDatabase(versionNumber?: number) {
    let migrationsToRun = this._migrations;

    if (versionNumber) {
      migrationsToRun = migrationsToRun.filter(m => m.versionNumber <= versionNumber);
    }

    migrationsToRun = migrationsToRun.sort((a, b) => a.versionNumber - b.versionNumber);

    for (const migration of migrationsToRun) {
      this._db
        .version(migration.versionNumber)
        .stores(migration.stores)
        .upgrade(migration.upgrader);
    }
  }
}

export class DexieMigration {
  versionNumber = 1;
  stores: { [tableName: string]: string } = {};
  upgrader: (trans: Transaction) => void;
  LocalDb;
  constructor(
    version: number,
    stores: { [tableName: string]: string },
    upgrader: (trans: Transaction) => void = () => {}
  ) {
    this.versionNumber = version;
    this.stores = stores;
    this.upgrader = upgrader;
  }
}

export const migrations: DexieMigration[] = [
  new DexieMigration(1, {
    [fields<LocalDb>().exampleTable]: `&${fields<Example>().name}`,
    [fields<LocalDb>().localConfigurations]: `[${fields<LocalConfiguration>().userId}+${
      fields<LocalConfiguration>().type
    }]`,
    [fields<LocalDb>().harvestActivityReports]: `&${fields<HarvestActivityReport>().id},
      ${fields<HarvestActivityReport>().teamId},
      ${fields<HarvestActivityReport>().shiftId},
      [${fields<HarvestActivityReport>().teamId}+${fields<HarvestActivityReport>().shiftId}],
      [${fields<HarvestActivityReport>().teamId}+${fields<HarvestActivityReport>().date}]
    `,
    [fields<LocalDb>().teams]: `${fields<TeamSync>().id}, ${fields<TeamSync>().activityId}`,
    [fields<LocalDb>().shifts]: `${fields<ShiftSync>().id}`,
    [fields<LocalDb>().activities]: `${fields<ActivitySync>().id}`,
    [fields<LocalDb>().machines]: `${fields<MachineSync>().id}`,
    [fields<LocalDb>().synchronizationStatus]: `${fields<SynchronizationStatus>().entity},${
      fields<SynchronizationStatus>().synchronizationState
    }`,
    [fields<LocalDb>().programmings]: `
      &${fields<ProgrammingSync>().id},
      ${fields<ProgrammingSync>().teamId},
      [${fields<ProgrammingSync>().teamId}+${fields<ProgrammingSync>().shiftId}],
      [${fields<ProgrammingSync>().teamId}+${fields<ProgrammingSync>().shiftId}+${
      fields<ProgrammingSync>().machineId
    }]
    `,
    [fields<LocalDb>().harvestActivityReportSyncStates]: `${
      fields<HarvestActivityReportSyncState>().harvestActivityReportId
    }, ${fields<HarvestActivityReportSyncState>().state}`,
  }),
];
